<template>
  <div class="setItemsDiv">




    <el-dialog :title="activityInfo.title" :visible.sync="showWeChatInfo" width="90%" :before-close="handleClose">
      <vote-wechat v-if="showWeChatInfo" :activityInfo="activityInfo"></vote-wechat>
    </el-dialog>


    <el-dialog title="活动链接" :visible.sync="dialogFormVisible" :modal-append-to-body="false" @close="clear"
      :width="dialogWidth">
      <!-- <div> 可发给业主 </div> -->
      <div class="qrcode" ref="qrCodeUrl" style="margin:50px auto;padding-left: 165px"></div>
      <div style="color: #36AAFF;">
        <!-- <router-link :to="'/activityIndex/'+activityId">{{activityLink}}</router-link> -->
        <br />

        <!--        <a :href="activityLink" >{{activityLink}}</a>-->
      </div>
      <div @click="copyData">
        <el-link type="primary">点击复制链接： {{ activityUrl }}</el-link>
      </div>

    </el-dialog>
    <el-row>
      <el-col :sm="1" :xl="2">&nbsp;</el-col>
      <el-col :sm="20" :xs="24">
        <el-card>
          <div>
            <div style="float: left">
              最近的投票
            </div>
            <div style="float: right">
              <el-button type="primary" @click="toCreate">创建投票</el-button>
            </div>
          </div>
          <div style="text-align: left">
            <el-table v-loading="loading" :data="activities" stripe :default-sort="{ prop: 'id', order: 'ascending' }"
              style="width: 100%" ref="multipleTable">
              <el-table-column prop="title" label="标题" width="200">
              </el-table-column>
              <el-table-column label="状态" fit>
                <template slot-scope="scope">
                  <el-tag type="info" size="small" v-if="date.getTime() < Date.parse(scope.row.startTime)">未开始</el-tag>
                  <el-tag type="danger" size="small"
                    v-else-if="new Date().getTime() > Date.parse(scope.row.endTime)">已结束</el-tag>
                  <el-tag type="success" size="small" v-else>进行中</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="活动时间" width="200">
                <template slot-scope="scope">
                  <div style="color: #999;">{{ scope.row.startTime | fmtDate }}</div>
                  <div style="color: #999;">{{ scope.row.endTime | fmtDate }}</div>
                  <div style="color: #999;"></div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="500px">
                <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="editActivity(scope.row)">编辑</el-button>
                  <el-button size="mini" type="primary" @click="editCandidate(scope.row)">作品管理</el-button>
                  <el-button size="mini" type="primary" @click="showWechatInfo(scope.row)">公众号设定</el-button>
                  <el-button size="mini" type="success" @click="toVoteResult(scope.row)">统计</el-button>
                  <!-- <el-button size="mini" type="warning" @click="showQrCode(scope.row)">二维码</el-button> -->

                </template>
              </el-table-column>
            </el-table>
            <div style="float: left;padding: 15px">
              <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                :total="totalSize">
              </el-pagination>
            </div>
          </div>
        </el-card>

      </el-col>

    </el-row>
    <el-row v-show="false">
      <el-col :sm="1" :xl="2">&nbsp;</el-col>
      <el-col :sm="20" :xs="24">
        <el-card style="margin-top: 20px">
          <div style="float: left;margin-bottom: 20px">
            最新公告
          </div>
          <div style="text-align: left;">
            <el-table v-loading="noticeLoading" :data="notices" stripe :default-sort="{ prop: 'id', order: 'ascending' }"
              style="width: 100%" ref="multipleTable" show-overflow-tooltip>
              <el-table-column label="标题" fit>
                <template slot-scope="scope">
                  <router-link :to="'/notice/detail/' + scope.row.id" class="notice-link">{{ scope.row.title
                  }}</router-link>
                </template>
              </el-table-column>
              <el-table-column label="发布时间" fit>
                <template slot-scope="scope">
                  <div style="color: #999;">{{ scope.row.createTime | fmtDate }}</div>
                </template>
              </el-table-column>
            </el-table>
            <div style="float: left;padding: 15px">
              <el-pagination @current-change="handleNoticeCurrentChange" :current-page="noticeCurrentPage"
                :page-size="noticePageSize" :total="noticeTotalSize">
              </el-pagination>
            </div>
          </div>
        </el-card>

      </el-col>

    </el-row>
  </div>
</template>

<script>

import {
  webUrl, menuData
} from "@/utils/common/url.js";
import QRCode from 'qrcodejs2';

import VoteWechat from "./VoteWechat.vue";
export default {
  name: 'ListActivity',
  components: {
    VoteWechat
  },
  data() {
    return {
      showWeChatInfo: false,
      activityInfo: {},
      weChatInfoList: [],
      webUrl: webUrl,
      menuData: menuData,
      noticeLoading: false,
      loading: false,
      dialogWidth: '500px',
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      noticeCurrentPage: 1,
      noticePageSize: 4,
      noticeTotalSize: 0,
      notices: [],

      activities: [],
      voteItems: [],
      date: new Date(),
      date_1: '',
      dialogFormVisible: false,
      activityLink: '',
      activityUrl: '',
      activityId: '',
      cur_date: this.$options.filters.fmtDate(new Date())
    }
  },
  mounted() {


    //获取router参数
    var token = this.$route.query.token;
    console.log("token", token)
    console.log("this.$route.query", this.$route.query)

    var user = {
      userName: this.$route.query.uid,
      password: this.$route.query.password,
      companyId: this.$route.query.companyId
    }

    if (this.$route.query.uid) {
      this.$store.commit('login', user);
      this.$store.commit('token', token);

      //将 user 放入sessionStorage
      sessionStorage.setItem('user', JSON.stringify(user));
      //将 token 放入sessionStorage
      sessionStorage.setItem('token', token);
    } else {
      //获取sessionStorage中的user对象
      var user = JSON.parse(sessionStorage.getItem('user'));
      console.log("sessionStorage-user", user)
      this.$store.commit('login', user);

    }




    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
    this.listActivity()
    this.listNotice()
    // 初始化menu
    this.initAdminMenu(this.router, this.store)
    this.getWeChatInfo();

  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.showWeChatInfo = false;
          done();
        })
        .catch(_ => { });
    },

    /**
     * 
     * @param {显示微信公众号信息} activity 
     */
    showWechatInfo(activity) {


      this.activityInfo = activity;


      this.showWeChatInfo = !this.showWeChatInfo;
    },

    getWeChatInfo() {


      let _this = this
      const config = {
        headers: { 'token': this.$store.state.token }
      };

      this.$axios.get('/admin/activity/getWeChatInfo', config

      )
        .then(resp => {
          if (resp && resp.data.code === 200) {
            if (resp.data.result != null && resp.data.result.length > 0) {
              this.weChatInfoList = resp.data.result;


              this.$store.commit('SET_WECHATINFOLIST', this.weChatInfoList);
            }
          }
        })
    },


    // 点击复制链接
    copyData() {
      //如果不需要回调：
      this.$copyText(this.activityUrl)
      //如果需要回调：
      this.$copyText(this.activityUrl).then(e => {
        this.$message.success("复制成功")
      }, function (e) {
        this.$message.success("复制失败")
      })
    },


    initAdminMenu(router, store) {
      if (this.$store.state.adminMenus.length > 0) {
        return;
      }

      var fmtRoutes = this.formatRoutes(this.menuData)
      console.log(fmtRoutes)
      this.$router.addRoutes(fmtRoutes)
      this.$store.commit('initAdminMenu', fmtRoutes)

    },
    formatRoutes(routes) {
      let fmtRoutes = []
      routes.forEach(route => {
        if (route.children) {
          route.children = this.formatRoutes(route.children)
        }

        let fmtRoute = {
          path: route.path,
          component: resolve => {
            require(['@/components/admin/' + route.component + '.vue'], resolve)
          },
          name: route.name,
          nameZh: route.nameZh,
          iconCls: route.iconCls,
          meta: {
            requireAuth: true
          },
          children: route.children
        }
        fmtRoutes.push(fmtRoute)
      })
      return fmtRoutes
    },
    listActivity() {


      let _this = this
      const config = {
        headers: { 'companyId': encodeURIComponent(_this.$store.state.user.companyId) }
      };

      this.loading = true
      this.$axios.get('/admin/activity/list/self?page=' + _this.currentPage
        + '&size=' + _this.pageSize
        + '&companyId=' + _this.$store.state.user.companyId
        + '&userName=' + (_this.$store.state.user.userName ? _this.$store.state.user.userName : 'admin'), config

      )
        .then(resp => {
          if (resp && resp.data.code === 200) {
            _this.activities = resp.data.result.content
            _this.totalSize = resp.data.result.totalElements
            _this.loading = false
          }
        })
    },
    toCreate() {
      this.$store.state.curCreateActivity = []
      // vote/AddActivity
      this.$router.replace('/admin/vote/add/index')
    },
    editActivity(activity) {
      this.$store.commit('createActive', activity)
      console.log(this.$router)
      this.$router.push('/admin/vote/add/index')
      // this.$router.push({path:'/CreateNav'})
    },
    editCandidate(activity) {
      this.$store.commit('createActive', activity)
      this.$router.replace('/admin/vote/add/item')
    },
    toVoteResult(activity) {
      this.$store.commit('createActive', activity)
      this.$router.replace('/admin/vote/list/result')
    },
    showQrCode(activity) {

      var config = {};
      if (this.weChatInfoList.length > 0) {
        config = this.weChatInfoList[0];
      } else {
        this.$message({
          message: '请先配置微信公众号信息',
          type: 'warning'
        });
        return;
      }

      this.dialogFormVisible = true
      this.activityId = activity.id
      this.activityLink = this.webUrl + '/activityIndex/' + activity.id
      // this.activityUrl = 'http://192.168.31.102:88/geecityapi/get?appid=wxf014d14d5974b029&type=vote&businessKey='+activity.id
      this.activityUrl = 'http://' + config.domainName + '/geecityapi/get?appid=' + config.appId + '&type=vote&businessKey=' + activity.id;
      this.$nextTick(function () {
        this.creatQrCode()
      })
    },

    creatQrCode() {
      let qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.activityUrl, // 需要转换为二维码的内容
        width: 120,
        height: 120,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    clear() {
      this.dialogFormVisible = false
      this.$refs.qrCodeUrl = ''
    },

    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.listActivity()
    },
    handleNoticeCurrentChange(noticeCurrentPage) {
      this.currentPage = noticeCurrentPage
      this.listNotice()
    },
    listNotice() {
      let _this = this
      this.noticeLoading = true
      this.$axios.get('/notice/list?page=' + _this.noticeCurrentPage
        + '&size=' + _this.noticePageSize)
        .then(resp => {
          if (resp && resp.data.code === 200) {
            _this.notices = resp.data.result.content
            _this.totalSize = resp.data.result.totalElements
            _this.noticeLoading = false
          }
        })
    },
  },
  setDialogWidth() {
    let val = document.body.clientWidth
    const def = 500 // 默认宽度
    if (val < def) {
      this.dialogWidth = '100%'
    } else {
      this.dialogWidth = def + 'px'
    }
  },

}
</script>

<style>
.notice-link {
  color: #999;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vote/ListActivity.vue